import './VoucherSummary.scss';
import React from 'react';
import { Grid, Table, TableBody, TableCell, TableRow, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useOrderPage } from '../orderPageContext/useOrderPage';
import { OrderPageData, VoucherOut } from '../../api';
import { useLanguage } from '../../utils/GeneralUtils';
import { OrderPageTypography } from '../themedComponents/OrderPageTypography';
import { getSummaryData } from '../orderUtils/getSummaryData';
import { RescheduleFeeTiersTable } from '../../shared/ui/RescheduleFeeTiersTable';

type TableRowType = {
  key: string;
  icon: React.ElementType;
  value?: string | number | boolean;
};

export enum CustomDetailType {
  str = 'str',
  location = 'location',
  bool = 'bool',
  resourceInt = 'resourceInt',
}

type Label = {
  en: string;
  he: string;
};
export type CustomDetail = {
  name: string;
  icon?: string;
  type: CustomDetailType;
  label?: Label;
};
export type OrderCustomDetails = {
  [key: string]: number | boolean;
};
const VoucherSummary = ({ voucher }: { voucher: VoucherOut }) => {
  const { t } = useTranslation();
  const language = useLanguage();
  const theme = useTheme();
  const { orderPageState } = useOrderPage();

  if (!voucher) {
    return null;
  }
  const rows = getSummaryData({
    custom_details: voucher.custom_details,
    duration: orderPageState.details.duration,
    language,
    orderPage: orderPageState.orderPage,
    persons: voucher.persons,
    voucher,
    t,
    activityLabelSingular: orderPageState.account?.activity_label_singular?.[language] || '',
    account: orderPageState.account,
  });
  return (
    <div className="details-step">
      <Grid container>
        <Grid item mb={4}>
          <OrderPageTypography variant="h3" bold>
            {t('vouchers.redeemtitle')}
          </OrderPageTypography>
        </Grid>

        <Table className="table">
          <TableBody>
            {rows.map((row: TableRowType) => (
              <TableRow key={row.key}>
                <TableCell className="table-cell icon-cell">
                  <row.icon style={{ color: theme.customTheme.palette.primary }} />
                </TableCell>
                <TableCell className="table-cell">
                  <OrderPageTypography variant="h6" bold>
                    {row.key}
                  </OrderPageTypography>
                </TableCell>
                <TableCell className="table-cell">
                  <OrderPageTypography variant="h6">{row.value}</OrderPageTypography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        <RescheduleFeeTiersTable
          collapsible
          policy={(orderPageState.orderPage as OrderPageData).effective_reschedule_policy}
          account={orderPageState.account}
        />
      </Grid>
    </div>
  );
};

export default VoucherSummary;
